import { InstructorPageWrapper, withHTMLHeadSEO } from 'components/common';
import AssessmentDetail from 'components/features/grading-progress/AssessmentDetail';

const AssessmentDetailPage = () => <InstructorPageWrapper>{() => <AssessmentDetail />}</InstructorPageWrapper>;

export { AssessmentDetailPage as BaseAssessmentDetailPage };
export default withHTMLHeadSEO({ title: 'Assignment Name - Submission' })(AssessmentDetailPage);
